export default __webpack_public_path__ + "assets/png/0954ae05bb10dced6efa69437a9a309a.png";